import { render, staticRenderFns } from "./ContentSlider.vue?vue&type=template&id=460896f6&scoped=true&"
import script from "./ContentSlider.vue?vue&type=script&lang=js&"
export * from "./ContentSlider.vue?vue&type=script&lang=js&"
import style0 from "./ContentSlider.vue?vue&type=style&index=0&id=460896f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460896f6",
  null
  
)

export default component.exports